import { useQuery } from '@tanstack/react-query';
import StationsApi from '../lib/api/StationsApi';

/**
 * Single station lookup, e.g. for a `?stationId=` deep link into the detail
 * dialog.
 *
 * `enabled: !!id` is load-bearing: the consuming page renders unconditionally
 * and only sometimes has a station id available, so an unguarded query would
 * fire `GET /admin/stations/undefined` on every visit.
 */
const useStation = (id) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['station', id],
    queryFn: () => StationsApi.getStation(id),
    enabled: !!id,
  });

  return { station: data, isLoading, error };
};

export default useStation;
